import {Component, OnInit} from '@angular/core';
import {FormComponent} from '@ngx-ivengi/crud';
import {UIRouter} from '@uirouter/angular';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import {User} from '../user/user.model';
import {UserService} from '../user/user.service';
import {Price} from './price.model';
import {PriceService} from './price.service';
import { priceType } from './price.enum';

@Component({
  selector: 'app-price-form',
  templateUrl: './price-form.component.html'
})
export class PriceFormComponent extends FormComponent implements OnInit {

  public priceTypes = Object.keys(priceType).map((key) => priceType[key]).filter((value) => typeof value === 'string');
  public price: Price = new Price();
  public formTitle: string;
  public stateIdParam: string = 'priceId';

  constructor(
    protected router: UIRouter,
    private priceService: PriceService,
    private translate: TranslateService
  ) {
    super(router);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    switch(this.formMode) {
      case this.FormMode.ADD: {
        this.translate.get('price.form.add.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });
      } break;

      case this.FormMode.UPDATE: {
        this.priceService.get(this.router.stateService.params[this.stateIdParam]).subscribe((price) => {
          this.price = price;
        });

        this.translate.get('price.form.update.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });
      } break;
    }
  }

  public fileChange(evt) {
    this.price.setFile(evt.target.files);
  }

  public save(): void {
    switch(this.formMode) {
      case this.FormMode.ADD: {
        this.priceService.add(this.price).subscribe((result) => {
          this.router.stateService.go('management.price', this.router.stateService.params, {reload: true});
        });
      } break;

      case this.FormMode.UPDATE: {
        this.priceService.update(this.price).subscribe((result) => {
          this.router.stateService.go('management.price', this.router.stateService.params, {reload: true});
        });
      } break;
    }
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/price/price-form.component.ts